import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

function ScammerDetails() {
  const { id } = useParams();
  const [scammer, setScammer] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchScammer = async () => {
      try {
        const response = await fetch(`/api/get-submission-details?id=${id}`);
        const result = await response.json();
        
        if (result.success) {
          setScammer(result.submission);
        } else {
          setError(result.error || 'Scammer report not found');
        }
      } catch (err) {
        setError('Failed to load scammer details');
        console.error('Error fetching scammer:', err);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchScammer();
    }
  }, [id]);

  if (loading) {
    return (
      <div className="scammer-details-page">
        <div className="container">
          <div className="loading-state">
            <p>Loading scammer details...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error || !scammer) {
    return (
      <div className="scammer-details-page">
        <div className="container">
          <div className="error-state">
            <h1>Scammer Report Not Found</h1>
            <p>{error || 'The requested scammer report could not be found.'}</p>
            <a href="/scammers" className="cta-button">Back to Scammers</a>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="scammer-details-page">
      <div className="container">
        <div className="details-header">
          <h1>{scammer.username}</h1>
          <div className="scammer-meta">
            <span className="platform">{scammer.platform}</span>
            <span className="date">Reported {new Date(scammer.approvedAt).toLocaleDateString()}</span>
          </div>
        </div>

        <div className="details-content">
          <div className="description-section">
            <h2>Overview</h2>
            <p>{scammer.description}</p>
          </div>

          {scammer.markdownContent && (
            <div className="markdown-section">
              <h2>Full Report</h2>
              <div className="markdown-content">
                <ReactMarkdown 
                  remarkPlugins={[remarkGfm]}
                  components={{
                    img: ({ src, alt }) => (
                      <img 
                        src={src} 
                        alt={alt} 
                        style={{ 
                          maxWidth: '100%', 
                          height: 'auto',
                          borderRadius: '8px',
                          margin: '1rem 0'
                        }} 
                      />
                    )
                  }}
                >
                  {scammer.markdownContent}
                </ReactMarkdown>
              </div>
            </div>
          )}

          {scammer.images && scammer.images.length > 0 && (
            <div className="images-section">
              <h2>Evidence Images</h2>
              <div className="images-grid">
                {scammer.images.map((image, index) => (
                  <div key={index} className="image-item">
                    <img 
                      src={image.url} 
                      alt={image.name}
                      onClick={() => window.open(image.url, '_blank')}
                    />
                    <p>{image.name}</p>
                  </div>
                ))}
              </div>
            </div>
          )}

          <div className="back-section">
            <a href="/scammers" className="cta-button secondary">← Back to Scammers</a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ScammerDetails;
